function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isEmpty } from "lodash-es";
import BaseModal from "react-modal";
import { useStateToRef } from "../../helpers/hooks";
import ModalHeader from "./ModalHeader";
import ModalFooter from "./ModalFooter";
import ModalBody from "./ModalBody";
import ModalSidebar from "./ModalSidebar";
export const Context = /*#__PURE__*/createContext({
  onCancel: () => {}
});
const Modal = props => {
  const [height, setHeight] = useState();
  const onCancelRef = useStateToRef(props.onCancel);
  const heightRef = useStateToRef(height);
  useEffect(() => {
    const onKeyUp = event => {
      if (event.key === "Escape") {
        onCancelRef.current();
      }
    };
    const onResize = () => {
      if (!["fullscreen", "quickbar"].includes(props.size)) return;
      const vh = window.innerHeight;
      const newHeight = `${vh}px`;
      if (newHeight !== heightRef.current) {
        setHeight(newHeight);
      }
    };
    onResize();
    window.addEventListener("keyup", onKeyUp, false);
    window.addEventListener("resize", onResize, false);
    return () => {
      window.removeEventListener("keyup", onKeyUp, false);
      window.removeEventListener("resize", onResize, false);
    };
  }, []);
  return /*#__PURE__*/React.createElement(BaseModal, _extends({}, props, {
    overlayClassName: "modal-overlay",
    className: classNames(`tui-modal ${props.className} ${props.size}`, {
      "without-header": isEmpty(props.header)
    }),
    appElement: props.appElement || document.querySelector("div") || document.querySelector("body"),
    style: {
      content: {
        ...props.style,
        height
      }
    },
    onRequestClose: props.onCancel,
    shouldCloseOnOverlayClick: props.closeOutside && !props.isLoading && !props.isSubmitting,
    aria: {
      busy: props.isLoading || props.isSubmitting
    }
  }), /*#__PURE__*/React.createElement(Context.Provider, {
    value: {
      onCancel: props.onCancel,
      isLoading: props.isLoading,
      isSubmitting: props.isSubmitting
    }
  }, props.header && /*#__PURE__*/React.createElement(ModalHeader, {
    closeButton: props.closeButton && !props.isLoading && !props.isSubmitting
  }, props.header), props.children));
};
Modal.displayName = "Modal";
Modal.defaultProps = {
  appElement: undefined,
  style: {},
  size: "md",
  className: "",
  header: "",
  closeButton: false,
  closeOutside: true,
  children: /*#__PURE__*/React.createElement(ModalBody, null),
  onCancel: () => {},
  isLoading: false,
  isSubmitting: false
};
Modal.propTypes = {
  appElement: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  style: PropTypes.object,
  size: PropTypes.string,
  className: PropTypes.string,
  header: PropTypes.node,
  closeButton: PropTypes.bool,
  closeOutside: PropTypes.bool,
  children: PropTypes.node,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool
};
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Sidebar = ModalSidebar;
export default Modal;
//# sourceMappingURL=Modal.js.map